// extracted by mini-css-extract-plugin
module.exports = {"container":"_28_F_Ps1A2407Mnksyas-L"};